import type {CompanyVehicle} from "../types";

import type {ShiftCompanyVehicleRef} from "./shift-company-vehicles";

function unwrapCreateResponseRow(raw: unknown): Record<string, unknown> | null {
  const root = raw && typeof raw === "object" ? (raw as Record<string, unknown>) : null;
  if (!root) return null;
  const inner = root.data && typeof root.data === "object" ? (root.data as Record<string, unknown>) : root;
  return inner;
}

/**
 * POST /vehicle-condition-checks returns `{ data: { ...row }, meta }` (or the row at top level).
 * Used to reconcile `active-shift` when GET /shifts lags; nested vehicle populates the next list row.
 * after a successful start check.
 */
export function parseVehicleConditionCheckCreateResponse(
  raw: unknown,
): {shift_id: number; company_vehicle: CompanyVehicle & {company_vehicle_id?: number}} | null {
  const row = unwrapCreateResponseRow(raw);
  if (!row) return null;
  const rawSid = row.shift_id;
  const shiftId =
    typeof rawSid === "number" && Number.isFinite(rawSid) ? rawSid : Number(rawSid);
  if (rawSid == null || !Number.isFinite(shiftId)) return null;
  const cv = row.company_vehicle;
  if (!cv || typeof cv !== "object") return null;
  return {
    shift_id: shiftId,
    company_vehicle: cv as CompanyVehicle & {company_vehicle_id?: number},
  };
}

/** Row for `Shift.company_vehicle` from nested vehicle on check create response. */
export function companyVehicleCustodyFromCheckNested(
  v: CompanyVehicle & {company_vehicle_id?: number},
): ShiftCompanyVehicleRef | null {
  const idRaw = v.id ?? v.company_vehicle_id;
  if (idRaw == null || !Number.isFinite(Number(idRaw))) return null;
  const id = Number(idRaw);
  const row: CompanyVehicle = {...v, id};
  return {
    id,
    name: (row.label ?? row.name)?.trim() || undefined,
    unit_number: row.unit_number,
    plate: row.plate,
    make: row.make,
    model: row.model,
  };
}
